import React, { PureComponent } from "react";
import P5Wrapper from "react-p5-wrapper";

const sketch = p => {
  const distance = 25;
  const repelRadius = 150;
  let width = 800;
  let height = 800;
  let centerX = width / 2;
  let centerY = height / 2;
  let originX = width / 2;
  let originY = height / 2;
  let youCanTouchMeNow = false;
  const constrainDistance = val => p.constrain(val / repelRadius, -1, 1);

  p.myCustomRedrawAccordingToNewPropsHandler = props => {
    const dimensions = props.dimensions;
    if (width !== dimensions.width || height !== dimensions.height) {
      width = dimensions.width;
      height = dimensions.height;
      centerX = width / 2;
      centerY = height / 2;
      p.resizeCanvas(width, height);
    }
    youCanTouchMeNow = !!props.youCanTouchMeNow;
  };

  p.setup = () => {
    // p.pixelDensity(p.displayDensity());
    p.createCanvas(width, height);
    p.stroke("blue");
  };

  p.draw = () => {
    if (youCanTouchMeNow) {
      return;
    }
    p.clear();

    const distanceX = constrainDistance(originX - p.mouseX);
    const distanceY = constrainDistance(originY - p.mouseY);

    // make origin move to center
    originX += (centerX - originX) / 8;
    originY += (centerY - originY) / 8;

    // make origin move away from the mouse
    originX += 20 / distanceX * (1 - Math.abs(distanceY));
    originY += 20 / distanceY * (1 - Math.abs(distanceX));

    // top
    drawRange(0, 0, width, 0);
    // right
    drawRange(width, 0, width, height);
    // bottom
    drawRange(0, height, width, height);
    // left
    drawRange(0, 0, 0, height);
  };

  const drawRange = (x1, y1, x2, y2) => {
    const lines = p.dist(x1, y1, x2, y2) / distance;
    for (let i = 0; i < lines; i++) {
      const l = i / lines;
      const x = p.lerp(x1, x2, l);
      const y = p.lerp(y1, y2, l);
      p.line(x, y, originX, originY);
    }
  };
};

export default class DontTouchMe extends PureComponent {
  style = {
    // pointerEvents: "none",
    position: "relative"
  };

  componentDidMount() {
    this.setState({
      zIndex: this.props.getZIndex()
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isSafewordShouted && !prevProps.isSafewordShouted) {
      this.props.popScene(this.constructor);
    }
  }

  render() {
    return (
      <div style={{ ...this.style, ...this.state }}>
        <P5Wrapper {...this.props} sketch={sketch} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DontTouchMe/DontTouchMe.js